import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function MisCollection(props){
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rows, setRows] = useState([]);
  const [userData, setUserData] = useState([]);
  const [opData, setOp] = useState([]);
  const [ipData, setIp] = useState([]);
  const [refData, setRef] = useState([]);
  const [dueData, setDue] = useState([]);
  const [iprefData, setIpRef] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};
 const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};

  useEffect(() => {
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
      const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
      const [opResponse, ipResponse, refResponse, dueResponse, iprefResponse] = await Promise.all([
        axios.get(`${baseUrl}all-collection-view/?start_date=${startDateString}&end_date=${endDateString}&cashier=&mode=&status=2`),
        axios.get(`${baseUrl}all-ip-collection-view/?start_date=${startDateString}&end_date=${endDateString}&cashier=&mode=&status=2`),
        axios.get(`${baseUrl}refund-report-view/?start_date=${startDateString}&end_date=${endDateString}`),
        axios.get(`${baseUrl}due-report-view/?start_date=${startDateString}&end_date=${endDateString}`),
        axios.get(`${baseUrl}ip-refund-report-view/?start_date=${startDateString}&end_date=${endDateString}`),
      ]);
      setOp(opResponse.data);
      setIp(ipResponse.data);
      setRef(refResponse.data);
      setDue(dueResponse.data);
      setIpRef(iprefResponse.data);
    } catch (error) {
      console.log(error);
    }
  };
  fetchData();
  }, [startDate, endDate]);


    let TotalCons = 0;
    let TotalLab = 0;
    let TotalInv = 0;
    let TotalMin = 0;
    let TotalRef = 0;
    let TotalDue = 0;
    let TotalIpRef = 0;
    let TotalOpCash = 0;
    let TotalOpCard = 0;
    let totalOpTotal = 0;

    for (const payment of opData) {
       if (!isNaN(payment.paid)) {
        TotalCons += Number(payment.paid);
      }
      if (!isNaN(payment.lab_paid)) {
        TotalLab += Number(payment.lab_paid);
      }
      if (!isNaN(payment.inv_paid)) {
        TotalInv += Number(payment.inv_paid);
      }
      if (!isNaN(payment.min_paid)) {
        TotalMin += Number(payment.min_paid);
      }

      if (payment.mode === 'cash' || payment.lab_pmode === 'cash' || payment.inv_pmode === 'cash' || payment.min_pmode === 'cash') {
        if (!isNaN(payment.paid)) {
          TotalOpCash += Number(payment.paid);
        }
        if (!isNaN(payment.lab_paid)) {
          TotalOpCash += Number(payment.lab_paid);
        }
        if (!isNaN(payment.inv_paid)) {
          TotalOpCash += Number(payment.inv_paid);
        }
        if (!isNaN(payment.min_paid)) {
          TotalOpCash += Number(payment.min_paid);
        }
      }
      if (payment.mode === 'card' || payment.lab_pmode === 'card' || payment.inv_pmode === 'card' || payment.min_pmode === 'card') {
        if (!isNaN(payment.paid)) {
          TotalOpCard += Number(payment.paid);
        }
        if (!isNaN(payment.lab_paid)) {
          TotalOpCard += Number(payment.lab_paid);
        }
        if (!isNaN(payment.inv_paid)) {
          TotalOpCard += Number(payment.inv_paid);
        }
        if (!isNaN(payment.min_paid)) {
          TotalOpCard += Number(payment.min_paid);
        }
      }
    }
    for (const payment of refData) {
       if (!isNaN(payment.refund_amount)) {
        TotalRef += Number(payment.refund_amount);
      }
    }
    for (const payment of dueData) {
       if (!isNaN(payment.due_amount)) {
        TotalDue += Number(payment.due_amount);
      }
    }

    let TotalAdv = 0;
    let TotalIpLab = 0;
    let TotalIpInv = 0;
    let TotalIpCash = 0;
    let TotalIpCard = 0;
    let totalIpTotal = 0;

    for (const payment of ipData) {
      if (!isNaN(payment.paid)) {
        TotalAdv += Number(payment.paid);
      }
      if (!isNaN(payment.lab_paid)) {
        TotalIpLab += Number(payment.lab_paid);
      }
      if (!isNaN(payment.inv_paid)) {
        TotalIpInv += Number(payment.inv_paid);
      }

      if (payment.mode === 'cash' || payment.lab_pmode === 'cash' || payment.inv_pmode === 'cash') {
        if (!isNaN(payment.paid)) {
          TotalIpCash += Number(payment.paid);
        }
        if (!isNaN(payment.lab_paid)) {
          TotalIpCash += Number(payment.lab_paid);
        }
        if (!isNaN(payment.inv_paid)) {
          TotalIpCash += Number(payment.inv_paid);
        }
      }
      if (payment.mode === 'card' || payment.lab_pmode === 'card' || payment.inv_pmode === 'card') {
        if (!isNaN(payment.paid)) {
          TotalIpCard += Number(payment.paid);
        }
        if (!isNaN(payment.lab_paid)) {
          TotalIpCard += Number(payment.lab_paid);
        }
        if (!isNaN(payment.inv_paid)) {
          TotalIpCard += Number(payment.inv_paid);
        }
      }
    }


    for (const payment of iprefData) {
       if (!isNaN(payment.refund_amount)) {
        TotalIpRef += Number(payment.refund_amount);
      }
    }
   totalOpTotal += (TotalCons+TotalLab+TotalInv+TotalMin);
   totalIpTotal += (TotalAdv+TotalIpLab+TotalIpInv);

  const today = new Date();

  const handlePrint = () => {
        const printContents = document.getElementById('invoice-print').innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        document.body.innerHTML = originalContents;
     };

  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'black', backgroundColor: '#e5eaef'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i>MIS Dashboard</h3>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
            <div className="col-sm-9 col-lg-10 controls">
            <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderheaderName="Please select From date"
                dateFormat="dd/MM/yyyy"
            />
            </div>
            <div className="col-sm-9 col-lg-10 controls">
            <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                maxDate={today}
                placeholderheaderName="Please select To date"
                dateFormat="dd/MM/yyyy"
            />
            </div>
            </div>
        </div>
      </div>

        <div className="table-responsive" id="invoice-print">
        <h3 className="text-center" style={{color: 'black', backgroundColor: '#e5eaef'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> MIS Report</h3>
            <table className="table table-bordered">
                <tbody>
                   <tr>
                   <td style={{ fontWeight: 'bold' }}>OP Collection</td>
                   <td style={{ fontWeight: 'bold' }}>OP Amount</td>
                   </tr>
                   <tr>
                   <td>Consult Fee</td>
                    <td>{TotalCons}</td>
                   </tr>
                   <tr>
                   <td>Lab</td>
                    <td>{TotalLab}</td>
                   </tr>
                   <tr>
                   <td>Radiology</td>
                    <td>{TotalInv}</td>
                   </tr>
                   <tr>
                    <td>Minor</td>
                    <td>{TotalMin}</td>
                   </tr>
                   <tr>
                    <td>Refund</td>
                    <td>{TotalRef}</td>
                   </tr>
                   <tr>
                    <td>Due Paid</td>
                    <td>{TotalDue}</td>
                   </tr>
                   <tr>
                   <td style={{ fontWeight: 'bold' }}>Total(Cons+Lab+Radiology+Minor)</td>
                   <td style={{ fontWeight: 'bold' }}>{totalOpTotal}</td>
                   </tr>
                   <tr>
                   <td style={{ fontWeight: 'bold' }}>IP Collection</td>
                   <td style={{ fontWeight: 'bold' }}>IP Amount</td>
                   </tr>
                   <tr>
                   <td>Advance Amount</td>
                    <td>{TotalAdv}</td>
                   </tr>
                   <tr>
                   <td>Lab</td>
                    <td>{TotalIpLab}</td>
                   </tr>
                   <tr>
                   <td>Radiology</td>
                    <td>{TotalIpInv}</td>
                   </tr>
                   <tr>
                    <td>Refund</td>
                    <td>{TotalIpRef}</td>
                   </tr>
                   <tr>
                   <td style={{ fontWeight: 'bold' }}>Total(Adv+Lab+Radiology)</td>
                   <td style={{ fontWeight: 'bold' }}>{totalIpTotal}</td>
                   </tr>
                   <tr>
                   <td style={{ fontWeight: 'bold' }}>OP Cash Total</td>
                   <td style={{ fontWeight: 'bold' }}>{TotalOpCash}</td>
                   </tr>
                   <tr>
                   <td style={{ fontWeight: 'bold' }}>OP Card Total</td>
                   <td style={{ fontWeight: 'bold' }}>{TotalOpCard}</td>
                   </tr>
                   <tr>
                   <td style={{ fontWeight: 'bold' }}>IP Cash Total</td>
                   <td style={{ fontWeight: 'bold' }}>{TotalIpCash}</td>
                   </tr>
                   <tr>
                   <td style={{ fontWeight: 'bold' }}>IP Card Total</td>
                   <td style={{ fontWeight: 'bold' }}>{TotalIpCard}</td>
                   </tr>
                </tbody>
            </table>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <button style={{ padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff' }}
              onClick={handlePrint}
              >
               Print
              </button>
            </div>

    </section>
  )
}

export default MisCollection;
